function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.444 7.226c0 5.051 4.055 9.146 9.058 9.146.44 0 .874-.032 1.298-.093A8.99 8.99 0 019.258 19.1C4.255 19.1.2 15.005.2 9.953.2 5.347 3.572 1.536 7.96.9a9.163 9.163 0 00-2.516 6.326z",
  fill: "currentColor",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
});

function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgMoon;